const AboutSection = () => {
  const scrollToSurvey = () => {
    const element = document.querySelector("#survey");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-32 bg-slate-50 geo-pattern"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-card">
              <img
                src="/images/about.jpg"
                alt="Hagyományos vályogház"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-blue-900 rounded-full opacity-10" />
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-blue-500 rounded-full opacity-10" />
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              CÉGÜNKRŐL
            </div>
            
            <h2
              className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Emberiség a profizmus mellett
            </h2>
            
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              Csapatunk olyan mesterekből áll, akik nemcsak ismerik, hanem valóban <em className="text-blue-900 not-italic font-semibold">értik</em> a vályogépítészet minden apró részletét. A tradicionális technikákat a legmodernebb szakmai eljárásokkal és precíz tervezéssel ötvözzük.
            </p>
            
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              Küldetésünk nem csupán házak építése: célunk, hogy visszahozzuk a természetes, egészséges és fenntartható otthonok kultúráját. A Vályog Mester több mint egy vállalkozás — egy mozgalom, amely a környezettudatos építkezés jövőjét formálja.
            </p>
            
            <button
              data-testid="about-cta-btn"
              onClick={scrollToSurvey}
              className="bg-blue-900 text-white px-8 py-4 text-lg font-bold rounded-full hover:bg-blue-800 transition-all shadow-button hover:scale-105 active:scale-95"
            >
              Ingyenes felmérés
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
